import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Megaphone, ArrowRight, Plus } from "lucide-react";
import { API } from "@/contexts/AuthContext";
import { PostCard } from "./Noticeboard";

export default function NoticeboardTeaser() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/noticeboard/recent`);
      setPosts(data || []);
    } catch (e) {
      console.error("Failed to load noticeboard teaser:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="bg-gradient-to-br from-[#F1E4D5] to-white rounded-3xl border border-[#F0E5DE] p-7" data-testid="noticeboard-teaser">
      <div className="flex items-end justify-between gap-3 mb-5 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-wider text-[#EA823A] font-semibold mb-1.5 flex items-center gap-2">
            <Megaphone className="w-3.5 h-3.5" /> Team noticeboard
          </div>
          <h2 className="font-display text-2xl text-[#1F2A2E]">What's happening</h2>
        </div>
        <Link to="/staff/noticeboard" className="text-sm text-[#E2718A] hover:text-[#1F2A2E] font-semibold flex items-center gap-1.5" data-testid="noticeboard-view-all">
          View all <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      {loading ? (
        <div className="py-8 text-center"><div className="w-6 h-6 border-3 border-[#E2718A] border-t-transparent rounded-full animate-spin mx-auto" /></div>
      ) : posts.length === 0 ? (
        <div className="bg-white border border-dashed border-[#F0E5DE] rounded-2xl py-10 text-center" data-testid="noticeboard-teaser-empty">
          <Megaphone className="w-8 h-8 mx-auto text-[#F4C3CC] mb-3" />
          <p className="text-sm text-[#284952] mb-1">No posts yet</p>
          <p className="text-xs text-[#6B7A80] mb-4">Share a win, a story, or ask the team for help.</p>
          <Link to="/staff/noticeboard" className="inline-flex items-center gap-2 text-sm font-semibold text-[#E2718A] hover:text-[#284952]">
            <Plus className="w-4 h-4" /> Start the conversation
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {posts.map((p) => (
            <Link key={p.id} to="/staff/noticeboard" className="block hover:opacity-95 transition" data-testid={`teaser-post-${p.id}`}>
              <PostCard post={p} compact />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
